import { NameIdOption } from "../../../../../common/types/commonTypes";

export const NO_HR_REPRESENTATIVE_ID = "noHrRep";

export const buildExpertOptions = (
  experts: NameIdOption[],
  includeNoHrRep: boolean,
  noHrRepOption: NameIdOption,
): NameIdOption[] => {
  const sorted = [...experts].sort((a, b) =>
    a.name.localeCompare(b.name, "fi"),
  );
  return includeNoHrRep ? [noHrRepOption, ...sorted] : sorted;
};

export const normalizeSelectedExpertValues = (
  value: NameIdOption[] | undefined,
  options: NameIdOption[],
): NameIdOption[] =>
  (value || []).map((selected) => {
    const match = options.find((option) => option.id === selected.id);
    return match || selected;
  });
